import React from 'react';
const kennitala = require('kennitala')
import { Spinner, getPaymentKeyText } from '../../utils'
import { gettext } from '../../locale'
import moment from 'moment'

import ContractLine from '../contract-line'

import 'chartjs-plugin-colorschemes';

/*
301: örorkubætur
302: dánarbætur v/slyss
303: sjúkrahúsdagpeningar
306: lýtaaðgerðir
307: björgunarkostnaður
312: tekjulífeyrir
317: tafarlausar bætur
318: bráðabætur
352: viðbótarvernd
351: slysaráðgjafi
350: tvöfaldur tekjulífeyrir eingöngu fyrir <28 ára
*/

class OfferRis extends React.Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    render() {

        let customer = this.props.customer
        // let offer = this.props.offers.offers[this.props.customerId][this.props.offerType]

        // let offer = this.props.offers.offers[customer.Customer.AccountNum][this.props.offerType]
        let offer = this.props.offer[this.props.offerType]
        let parameters = offer.parameters
        let keyFigures = offer.keyFigures

        if (offer.isFetching || this.props.customer.isFetching) {
            return <Spinner />
        }

        if (offer.error) {
            return (<>
                { offer.errorMessage }
            </>)
        }

        

        let paymentTextKey = getPaymentKeyText(this.props.infoCollection["RISpaymentfrequency"])


        return (<>
                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <h3>Persónuupplýsingar</h3>
                        {customer.Customer.Name}<br />

                        Dagsetning tilboðs {moment.utc().format("D.M.YYYY")}

                    </div>
                </div>

                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <h3>Forsendur útreikninga</h3>
                        <table className="table table-hover table-sm table-offer table-responsive-sm">
                            <tbody>
                                <tr>
                                    <td>
                                        <strong>{gettext("startDate")}</strong> ({gettext("startDate", "de")})
                                    </td>
                                    <td className="text-right nowrap">
                                        {parameters.start.format("D.M.YYYY")}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{gettext("contractLength")}</strong> ({gettext("contractLength", "de")})
                                    </td>
                                    <td className="text-right nowrap">
                                        {parameters.length} ár
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{gettext("riskGroup")}</strong> ({gettext("riskGroup", "de")})
                                    </td>
                                    <td className="text-right nowrap">
                                        {offer['data']['Angebot']['Tarifierung']['Verkaufsprodukt']['Produkt']['Elementarprodukt'][0]['VersichertePerson']['Gefahrengruppe']}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>

                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">

                        <h3>{gettext("ris.amountHeading")} ({gettext("ris.amountHeading", "de")})</h3>
                        <table className="table table-hover table-sm table-offer table-responsive-sm">
                            <tbody>
                                <ContractLine name="ris.disability_amount" value={keyFigures["ns25:STE_DeckungBasis-0301"]} currencyExchange={this.props.currencyExchange} />
                                <tr><td>Örorkubætur frá 1% á sambærilegan hátt, auk þess gildir stigvaxandi örorkuþrep 500.<br/>(Invaliditätsleistung ab 1 % entsprechend dem Invaliditätsgrad, zusätzlich gilt die progressive Invaliditätsstaffel 500.)</td><td></td></tr>
                                {keyFigures['ns25:STE_DeckungErweiterung-000352'] ?
                                    <ContractLine name="ris.disability_fivefold_amount" value={parseInt(keyFigures["ns25:STE_DeckungBasis-0301"])*5} currencyExchange={this.props.currencyExchange} /> 
                                    :
                                    <ContractLine name="ris.disability_fivefold_amount_100" value={parseInt(keyFigures["ns25:STE_DeckungBasis-0301"])*5} currencyExchange={this.props.currencyExchange} /> 
                                }
                                <tr className="no-hover-color"><td className="text-center" colSpan={2}>
                                    {keyFigures['ns25:STE_DeckungErweiterung-000352'] ?
                                        <img src={window.images.risVidbotarvernd} />
                                    :
                                        <img src={window.images.risAnVidbotarvernd} />
                                    }
                                </td></tr>
                                {keyFigures["ns25:STE_DeckungBasis-0312"] ?
                                    <ContractLine name="ris.monthly_pension" value={keyFigures["ns25:STE_DeckungBasis-0312"]} currencyExchange={this.props.currencyExchange}  />
                                    :
                                    <ContractLine name="ris.monthly_pension" value={0} noAmount={true} currencyExchange={this.props.currencyExchange}  />
                                }
                                {keyFigures["ns25:STE_DeckungBasis-0318"] ?
                                    <>
                                        <ContractLine name="ris.acute_benefits" value={0} noAmount={true} noAmountText="" currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.acute_benefits_sub_1" type="sub top" value={300} currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.acute_benefits_sub_2" type="sub" value={1500} currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.acute_benefits_sub_3" type="sub" value={3000} currencyExchange={this.props.currencyExchange}  />
                                    </>
                                    :
                                    <>
                                        <ContractLine name="ris.acute_benefits" value={0} noAmount={true} noAmountText="" currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.acute_benefits_sub_1" type="sub top" value={0} noAmount={true} currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.acute_benefits_sub_2" type="sub" value={0} noAmount={true} currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.acute_benefits_sub_3" type="sub" value={0} noAmount={true} currencyExchange={this.props.currencyExchange}  />
                                    </>
                                }

                                {keyFigures["ns25:STE_DeckungBasis-0303"] ?
                                    <>
                                        <ContractLine name="ris.hospital_pension_1_3" value={0} noAmount={true} noAmountText="" currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.hospital_pension_1_3_sub_1" type="sub top" value={parseInt(keyFigures["ns25:STE_DeckungBasis-0303"])} currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.hospital_pension_1_3_sub_2" type="sub" value={2*parseInt(keyFigures["ns25:STE_DeckungBasis-0303"])} currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.hospital_pension_1_3_sub_3" type="sub" value={3*parseInt(keyFigures["ns25:STE_DeckungBasis-0303"])} currencyExchange={this.props.currencyExchange}  />
                                    </>
                                    :
                                    <>
                                        <ContractLine name="ris.hospital_pension_1_3" value={0} noAmount={true} noAmountText="" currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.hospital_pension_1_3_sub_1" type="sub top" value={0} noAmount={true} currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.hospital_pension_1_3_sub_2" type="sub" value={0} noAmount={true} currencyExchange={this.props.currencyExchange}  />
                                        <ContractLine name="ris.hospital_pension_1_3_sub_3" type="sub" value={0} noAmount={true} currencyExchange={this.props.currencyExchange}  />
                                    </>
                                }

                                {keyFigures["ns25:STE_DeckungBasis-0302"] ?
                                    <ContractLine name="ris.accidental_death_benefits" value={keyFigures["ns25:STE_DeckungBasis-0302"]} currencyExchange={this.props.currencyExchange}  />
                                    :
                                    <ContractLine name="ris.accidental_death_benefits" value={0} noAmount={true} currencyExchange={this.props.currencyExchange}  />
                                }

                                {keyFigures["ns25:STE_DeckungBasis-0306"] ?
                                    <>
                                        <ContractLine name="ris.plastic_surgery" value={keyFigures["ns25:STE_DeckungBasis-0306"]} currencyExchange={this.props.currencyExchange}  />
                                        <tr className={"sub top"}><td>á einnig við um tannviðgerð og tannsmíð eftir slys.<br/>(auch bei Zahnbehandlung und Zahnersatz nach einem Unfall)</td><td></td></tr>
                                    </>
                                    :
                                    <>
                                        <ContractLine name="ris.plastic_surgery" value={0} noAmount={true} currencyExchange={this.props.currencyExchange}  />
                                        <tr className={"sub top"}><td>á einnig við um tannviðgerð og tannsmíð eftir slys.<br/>(auch bei Zahnbehandlung und Zahnersatz nach einem Unfall)</td><td></td></tr>
                                    </>
                                }

                                {keyFigures["ns25:STE_DeckungBasis-0307"] ?
                                    <ContractLine name="ris.rescue_cost" value={keyFigures["ns25:STE_DeckungBasis-0307"]} currencyExchange={this.props.currencyExchange}  />
                                    :
                                    <ContractLine name="ris.rescue_cost" value={0} noAmount={true} currencyExchange={this.props.currencyExchange}  />
                                }

                                {keyFigures["ns25:STE_DeckungBasis-0317"] ?
                                    <ContractLine name="ris.immediate_benefits" value={Math.min(Math.round(0.1 * parseFloat(keyFigures["ns25:STE_DeckungBasis-0301"])),25000)} currencyExchange={this.props.currencyExchange}  />
                                    :
                                    <ContractLine name="ris.immediate_benefits" value={0} noAmount={true} currencyExchange={this.props.currencyExchange}  />
                                }

                                <ContractLine name="ris.prostheses" value={10000} currencyExchange={this.props.currencyExchange}  />

                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <h3>{gettext("TotalHauptprodukt")} ({gettext("TotalHauptprodukt", "de")})</h3>
                        <table className="table table-hover table-sm table-offer table-responsive-sm">
                            <tbody>
                                <ContractLine name={paymentTextKey} value={keyFigures["Hauptprodukt"]} currencyExchange={this.props.currencyExchange} eurDecimals={2} />
                            </tbody>
                        </table>

                    </div>
                </div>


            </>)

    }
}

export default OfferRis
